import React from 'react'

function Jumbotron() {


    return (

        
            <div className="jumbotron jumbotron-fluid" style={{ padding: "30px"}}>
                <h1 className="display-2">Welcome to the blog!</h1>
                <p className="lead">Glad you came by. I wanted to welcome you and let you know I appreciate you spending time here at the blog. Everyone is so busy and life moves pretty fast, so I really do appreciate you taking time out of your busy day to check out my blog!</p>
            </div>
        

    )


}

export default Jumbotron